const dev = {
  BASE_URL: process.env.REACT_APP_STAGING_API_URL,
  BUILDING_URL: process.env.REACT_APP_BUILDING_URL,
  THERMOSTAT_SETUP_URL: process.env.REACT_APP_THERMOSTAT_SETUP_URL,
  THERMOSTAT_THERMOSTAT_URL: process.env.REACT_APP_THERMOSTAT_THERMOSTAT_URL,
  ALERTS_INCIDENTS_URL: process.env.REACT_APP_ALERTS_INCIDENTS_URL,
  ALERTS_ALERTS_URL: process.env.REACT_APP_ALERTS_ALERTS_URL,
  ALERTS_V2_URL: process.env.REACT_APP_ALERTS_V2_URL,
  ALERTS_V2_INCIDENTS_URL: process.env.REACT_APP_ALERTS_V2_INCIDENTS_URL,
  BUILDING_USERS_URL: process.env.REACT_APP_BUILDING_USERS_URL,
  TRACKING_URL: process.env.REACT_APP_TRACKING_URL,
  REACT_APP_ID: process.env.REACT_APP_STAGING_ID,
};

const prod = {
  BASE_URL: process.env.REACT_APP_PRODUCTION_API_URL,
  BUILDING_URL: process.env.REACT_APP_BUILDING_URL,
  THERMOSTAT_SETUP_URL: process.env.REACT_APP_THERMOSTAT_SETUP_URL,
  THERMOSTAT_THERMOSTAT_URL: process.env.REACT_APP_THERMOSTAT_THERMOSTAT_URL,
  ALERTS_INCIDENTS_URL: process.env.REACT_APP_ALERTS_INCIDENTS_URL,
  ALERTS_ALERTS_URL: process.env.REACT_APP_ALERTS_ALERTS_URL,
  ALERTS_V2_URL: process.env.REACT_APP_ALERTS_V2_URL,
  ALERTS_V2_INCIDENTS_URL: process.env.REACT_APP_ALERTS_V2_INCIDENTS_URL,
  BUILDING_USERS_URL: process.env.REACT_APP_BUILDING_USERS_URL,
  TRACKING_URL: process.env.REACT_APP_TRACKING_URL,
  REACT_APP_ID: process.env.REACT_APP_PRODUCTION_ID,
};

export const config = process.env.REACT_APP_BUILD_ENV === 'production' ? prod : dev;
